import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import bindActionCreators from "redux/es/bindActionCreators";
import reduxForm from "redux-form/es/reduxForm";
import Field from "redux-form/es/Field";
import {
  createOrUpdateCredit,
  getCreditDetails,
  toggleCreditDetails,
  deleteCredit
} from "../BillingActions";
import ReduxSearchableSelectField from "../../../components/reduxFields/ReduxSearchableSelectField";
import countriesData from "country-region-data";
import { injectStripe } from "react-stripe-elements";
import Clearfix from "../../../components/material-pro/Clearfix/Clearfix";
import GridContainer from "../../../components/material-pro/Grid/GridContainer";
import GridItem from "../../../components/material-pro/Grid/GridItem";
import InjectedCheckoutForm from "./InjectedCheckoutForm";
import SubmissionError from "redux-form/es/SubmissionError";
import Button from "../../../components/material-pro/CustomButtons/Button";
import ReduxInsideLabelTextField from "../../../components/reduxFields/ReduxInsideLabelTextField";
import { Translate } from "react-redux-i18n";
import { openConfirmationModal } from "../../../components/confirmation-modal/ConfirmationModalActions";
import withStyles from "@material-ui/core/es/styles/withStyles";
import injectedCheckoutFormStyles from "../jss/InjectedCheckoutFormStyles";
import {closeInfoModal} from './edit-info/EditInfoActions'


class BillingFrom extends Component {
  state = {
    selectedCountry: null,
    useCompanyDetails: false,
    error: "",
    selectedCountryFetched: false,
    checked: false,
    checkedError: false
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps != this.props &&
      this.state.selectedCountryFetched === false
    ) {
      this.setState({
        selectedCountry: this.props.billing.customer.addressCountry,
        selectedCountryFetched: true
      });
    }
  }

  getCountries = () => {
    const countriesOptions = [];
    countriesData.map(country =>
      countriesOptions.push({
        value: country.countryName,
        label: country.countryName
      })
    );
    return countriesOptions;
  };

  getRegions = country => {
    const regionOptions = [];
    if (country) {
      const selectedCountryRegions = countriesData.filter(
        c => c.countryName === country
      )[0].regions;
      selectedCountryRegions.map(region =>
        regionOptions.push({ value: region.name, label: region.name })
      );
    }
    return regionOptions;
  };

  handleCardErrors = e =>
    this.setState({ error: e.error ? e.error.message : "" });

  handlCheckboxeChange = event => {
    this.setState({ checkedError: false });
    this.setState({ checked: event.target.checked });
  };

  toggleDeleteHandler = () => {
    const { openConfirmationModal, deleteCredit, billing: { customer: { last4Digits } }, closeInfoModal } = this.props;
    closeInfoModal()
    openConfirmationModal({text: <div>Are you sure you wat to delete credit detailes</div>, callback: () => deleteCredit(last4Digits), confirmCheckbox: false, btn1: 'Cancel', btn2: 'Confirm'})
  }

  onSubmit = props => {
    const {
      company,
      stripe,
      createOrUpdateCredit,
      billing,
      billing: { useCompanyDetails },
      openConfirmationModal
    } = this.props;
    const { error, checked } = this.state;

    function submitFlow() {
      let ba = useCompanyDetails ? company.content : props;
      const region = ba.country === "United States" ? ba.region : null;
      const formattedInfo = {
        name: ba.name,
        addressCity: ba.city,
        addressCountry: ba.country,
        addressState: region,
        zipCode: ba.zip
      };
      if (!billing.customer.hasOwnProperty("last4Digits") ) {//&& checked
        if (error && error !== "") {
          throw new SubmissionError();
        }
        stripe
          .createToken({
            name: ba.name,
            address_city: ba.city,
            address_country: ba.country,
            address_state: ba.region,
            address_zip: ba.zip
          })
          .then(({ token }) => {
            if (token && token.id) {
              formattedInfo.token = token.id;
              createOrUpdateCredit(formattedInfo, props.email);
            } else {
              this.setState({
                error: (
                  // <Translate value="billing.creditDetailsModal.defaultError" />
                  'incomplete fields'
                )
              });
              throw new SubmissionError();
            }
          });
      } else {
        createOrUpdateCredit(formattedInfo, props.email);
      }
    }

    if (billing.customer.hasOwnProperty("last4Digits")) {// && checked
      submitFlow.bind(this)();
    } else {
      submitFlow.bind(this)();
    }
  };

  render() {
    const { handleSubmit, billing, toggleCreditDetails, openConfirmationModal, classes, closeInfoModal} = this.props;
    const { error, checked, checkedError } = this.state;

    const defaultPackagePrice = ((billing.defaultPlan && billing.defaultPlan.price || 0) / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });

    return (
      <form onSubmit={handleSubmit(this.onSubmit)} style={{position: 'relative', zIndex: '0', padding: '0 15px'}}>
        <div style={{ maxWidth: "1000px", margin: "auto" }}>
        <GridContainer justify="center" style={{width: '100%', margin: '0'}}>
            {!billing.customer.hasOwnProperty("last4Digits") && (
              <GridItem md={12} sm={12} xs={12}>
                <InjectedCheckoutForm
                  handleCardErrors={this.handleCardErrors}
                  error={error}
                />
              </GridItem>
            )}
          </GridContainer>
          <GridContainer justify="center" style={{marginTop: '45px'}}>
            <GridItem md={6} xs={12} sm={6}>
            <label className={classes.formLabel}>
              <Translate value="billing.Name" />
              <Field
                className={classes.formInputField}
                name="name"
                required
                component={ReduxInsideLabelTextField}
              />
              </label>
            </GridItem>
            <GridItem md={6} xs={12} sm={6}>
              <label className={classes.formLabel}>
                <Translate value="labels.Email" />
                <Field
                  className={classes.formInputField}
                  name="email"
                  required
                  component={ReduxInsideLabelTextField}
                />
              </label>
            </GridItem>
            <GridItem md={6} xs={12} sm={6}>
            <label className={classes.formLabel}>
              <Translate value="labels.Country" />
                <Field
                  name="country"
                  placeholder={<Translate value="labels.Country" />}
                  options={this.getCountries()}
                  component={ReduxSearchableSelectField}
                  onChange={(e, value) =>
                    this.setState({ selectedCountry: value })
                  }
                />
                </label>
            </GridItem>
            <GridItem md={6} xs={12} sm={6}>
              <label className={classes.formLabel}>
              <Translate value="labels.State" />
              <Field
                name="region"
                placeholder={<Translate value="labels.State" />}
                options={
                  this.state.selectedCountry === "United States"
                    ? this.getRegions(this.state.selectedCountry)
                    : []
                }
                component={ReduxSearchableSelectField}
                disabled={
                  this.state.selectedCountry !== "United States" &&
                  this.state.selectedCountry !== null
                }
              />
              </label>
            </GridItem>
            <GridItem md={6} xs={12} sm={6}>
              <label className={classes.formLabel}>
                <Translate value="labels.City" />
                <Field
                  className={classes.formInputField}
                  name="city"
                  component={ReduxInsideLabelTextField}
                />
              </label>
            </GridItem>
            <GridItem md={6} xs={12} sm={6}>
              <label className={classes.formLabel}>
                <Translate value="labels.Zip Code" />
                <Field
                  className={classes.formInputField}
                  name="zip"
                  required
                  component={ReduxInsideLabelTextField}
                />
              </label>
            </GridItem>
          </GridContainer>
          <div className={classes.modalActionsContainer}>
            <div>
                {billing.customer.hasOwnProperty("last4Digits") && (
                  <Button
                    simple
                    onClick={this.toggleDeleteHandler}
                    className={classes.deleteBillingBtn}>
                    Delete billing info
                  </Button>
                )}
            </div>
            <div>
              <Button
                    simple
                    onClick={closeInfoModal}
                    className={classes.cancelBtn}
                  >
                    <Translate value="buttons.cancel" />
                  </Button>
                  <Button
                    type="submit"
                    disabled={billing.deleting || billing.saving}
                    loading={billing.saving}
                    simple
                    onClick={handleSubmit(values =>
                      this.onSubmit({
                        ...values,
                        action: "save"
                      })
                    )}
                    className={classes.submitBtn}
                  >
                    <Translate value="buttons.save" />
                </Button>
            </div>
          </div>
          <Clearfix />
        </div>
      </form>
    );
  }
}

const validate = values => {
  const errors = {};
  const emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!values.email) {
    errors.email = <Translate value="validations.email.empty" />;
  } else if (!emailFormat.test(values.email)) {
    errors.email = <Translate value="validations.email.invalid" />;
  }
  if (!values.name) {
    errors.name = <Translate value="validations.name.empty" />;
  }
  if (!values.country) {
    errors.country = <Translate value="validations.country.empty" />;
  }
  if (!values.region && values.country === "United States") {
    errors.region = <Translate value="validations.state.empty" />;
  }
  if (!values.zip) {
    errors.zip = <Translate value="validations.zipCode.empty" />;
  }
  if (!values.cardName) {
    errors.cardName = <Translate value="validations.cardName.empty" />;
  }
  return errors;
};

const mapStateToProps = ({ billing, company }) => ({ billing, company });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCreditDetails,
      createOrUpdateCredit,
      toggleCreditDetails,
      openConfirmationModal,
      closeInfoModal,
      deleteCredit
    },
    dispatch
  );

export default connect(({ billing }) => ({ initialValues: billing.customer }))(
  reduxForm({
    form: "BillingFrom",
    validate,
    enableReinitialize: true
  })(connect(mapStateToProps, mapDispatchToProps)(injectStripe((withStyles(injectedCheckoutFormStyles)(BillingFrom)))))
);



// WEBPACK FOOTER //
// ./src/containers/billing/components/BillingForm.js